import {CheckCircleOutline} from '@mui/icons-material';
import { Tooltip } from "antd";
import { get } from "lodash";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import COLOR from "utils/constants/color";
import * as Sentry from "@sentry/react";
import { useLocation, useNavigate } from "react-router-dom";
import { useNotificationHistorias } from "utils/methods/firebaseSoyHistorias";
import { handleListStoryAiConfig } from "store/StoryAiCofig/thunks";
import { useDispatch } from "react-redux";
import { useConfirm } from 'components/UI/confirmProvider';

const Text = styled.span`
  color: ${COLOR.black500};
  font-size: 11px;
  margin-top: 2px;
  text-align: left;
`;

export default function ShareNotificationWithStudents({
  currentClass,
  currentUser,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [notificationData, setNotificationData] = useState([]);
  const [showNotification, setShowNotification] = useState([]);
  const { createCollectionSoyNotification, listenToNotificationSoyData } =
    useNotificationHistorias();
  const confirm = useConfirm();

  useEffect(() => {
    try {
      const classId = get(currentClass, "id", "");
      const currentUserId = currentUser?.id;

      if (!classId || !currentUserId) {
        console.warn(
          "Missing classId or currentUserId for notification listener"
        );
        return;
      }

      const handleDataChange = (notifications) => {
        if (notifications?.length > 0) {
          setNotificationData(notifications);
          setShowNotification(notifications);
        }
      };

      const handleError = (error) => {
        Sentry.captureException(error);
      };
// TODO will be re-enabled after testing.
      // const unsubscribe = listenToNotificationSoyData(
      //   classId,
      //   currentUserId,
      //   handleDataChange,
      //   handleError
      // );

      // return () => {
      //   if (unsubscribe && typeof unsubscribe === "function") {
      //     unsubscribe();
      //   }
      // };
    } catch (error) {
      console.log(error);
    }
  }, [currentClass, currentUser]);

  const onView = async (obj) => {
    try {
      const data = { ...obj, user_seen: JSON.parse(obj.user_seen) };
      data.user_seen.push(currentUser.id);
      data.user_seen = JSON.stringify(data.user_seen);

      createCollectionSoyNotification(data);

      const isEbookPath = [
        "/ebook",
        "/balconCulturalBook",
        "/stories",
        "/video",
      ].some((path) => location.pathname.includes(path));

      if (isEbookPath) {
        dispatch(
          handleListStoryAiConfig(
            {
              chapter: data?.data?.chapter,
              user_id: data?.created_by,
              class_id: data?.class_id,
            },
            currentUser?.role === "student"
          )
        );
      }

      navigate(data?.url);
    } catch (error) {
      Sentry.captureException(error);
      console.error(error);
    }
  };

  const showConfirm = (obj) => {
    try {
      const checkId = showNotification.some((item) => item.id === obj.id);
      if (!checkId) return;
      const user_seen = JSON.parse(obj?.user_seen);
      if (user_seen && !user_seen?.includes(currentUser?.id)) {
        confirm({
          icon: null,
          content: (
            <Text
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CheckCircleOutline
                style={{ color: "#83ce34", fontSize: 50, marginRight: 6 }}
              />
              <Tooltip title={obj?.message}>
                <strong
                  style={{ fontSize: 16, fontWeight: 500, color: "black" }}
                  className="text-wrap"
                >
                  {obj.message}
                </strong>
              </Tooltip>
              {/* <Button onClick={destroyAll}>Click to destroy all</Button> */}
            </Text>
          ),
          okText: "View",
          cancelText: "Cancel",
          onOk() {
            onView(obj);
          },
          onCancel() {
           // deleteCollectionSoyNotification(obj?.classId, obj.storyId)
          },
        });
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    if (notificationData.length > 0 && currentUser?.role === "student") {
      const displayNotification = (index) => {
        if (index < notificationData.length) {
          showConfirm(notificationData[index]);
          setTimeout(() => {
            displayNotification(index + 1);
          }, 500);
        }
      };

      displayNotification(0);
    }
  }, [notificationData]);

  return null;
}
